//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'user',
  components:{
 
  },
  data () {
    return {
      info: {
        nickname:'未登录',
        head:'/static/images/head.png',
      },
    }
  },
  created(){
    if(this.$func.getLocal('token')){
      this.getInfo();
    }else{
      this.$router.push({path:'/login'})
    }
  },
  mounted(){
  
  },
  methods:{
    getInfo(){
      this.$api.getInfo({}).then((res)=>{
        if(res){
          if(!Number(res.data.cid)){
              this.$router.push({path:'/login'})
              return false;
          }
          this.info = res.data;
          this.$func.setLocal('token',res.data.token);
        }
      })
    },
    out(){
      this.$func.confirm('确认退出账号？','温馨提示',()=>{
        this.$api.out({}).then((res)=>{
          // this.$func.setLocal('token','');
          this.$router.push({path:'/login'})
        })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/user.vue